import $ from 'jquery'

const popupOpenClass = 'popup--open'
const popupOpenBodyClass = 'page--has-open-popup'

export default class PopupController {
  constructor (element) {
    this._element = element
    this._popupOpenBodyClass = popupOpenBodyClass
    this._resolvePopupId()
    this._bindUIActions()
  }

  _resolvePopupId () {
    const popupId = this._element.getAttribute('data-popup')
    if (popupId) {
      this._popupId = popupId
      this._popupOpenBodyClass = popupOpenBodyClass + '--' + this._popupId
    }
  }

  open () {
    this._element.style.opacity = 0
    $(this._element).fadeTo(200, 1)
    this._element.classList.add(popupOpenClass)
    document.body.classList.add(this._popupOpenBodyClass)
  }

  close () {
    document.body.classList.remove(this._popupOpenBodyClass)
    $(this._element).fadeTo(200, 0)
    setTimeout(() => {
      this._element.style.display = 'none'
      this._element.classList.remove(popupOpenClass)
    }, 260)
  }

  isOpen () {
    return this._element.classList.contains(popupOpenClass)
  }

  _bindUIActions () {
    const innerCloseButtons = this._element.querySelectorAll('[data-close-popup=""]')
    for (const element of Array.from(innerCloseButtons)) {
      element.addEventListener('click', (e) => {
        this.close()
        e.preventDefault()
      })
    }

    if (this._popupId) {
      const openButtons = document.querySelectorAll('[data-open-popup="' + this._popupId + '"]')
      for (const element of Array.from(openButtons)) {
        element.addEventListener('click', (e) => {
          this.open()
          e.preventDefault()
        })
      }

      const closeButtons = document.querySelectorAll('[data-close-popup="' + this._popupId + '"]')
      for (const element of Array.from(closeButtons)) {
        const preventDefault = !element.getAttribute('data-close-popup-allow-default')
        element.addEventListener('click', (e) => {
          this.close()
          if (preventDefault) {
            e.preventDefault()
          }
        })
      }
    }
  }
}
